<template>
    <div class="link-segment" :style="styles"></div>
</template>

<script>
    export default {
        name: "link-segment",
        props: {
            width: {default: '1px'},
            vertical: {type: Boolean}
        },
        computed: {
            styles() {
                let styles = {}
                if (!!this.vertical) {
                    styles.height = '100%'
                    styles.width = this.width
                } else {
                    styles.width = '100%'
                    styles.height = this.width
                }
                return styles
            },
        },
    }
</script>

<style lang="scss">
    .link-segment {
        box-sizing: border-box;
    }
</style>
